import httpClient from "./httpClient";
import Qs from "qs";

const getTimes = (params) => httpClient.get(`/record/list-times/current-user/`,{
    params:params,
})

const getLastTimes = (params) => httpClient.get(`/record/times/`,{
    params: params,
    paramsSerializer: function(params) {
        return Qs.stringify(params, {arrayFormat: 'repeat'})
    }
})



const updateTimes = (params) => httpClient.put(`/record/update-time/`,params)
const deleteTime = (id) => httpClient.delete(`/record/delete-time/?time_id=${id}`)




export {
    getTimes,
    updateTimes,
    deleteTime,
    getLastTimes,
}
